import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RouteShareService } from 'src/app/shared/services/route-share.service';
import { SkillUsageService, SkillUsageStageHit } from 'src/app/shared/services/skill-usage.service';

@Component({
  selector: 'app-skill-usage-list',
  templateUrl: './skill-usage-list.component.html',
  styleUrl: './skill-usage-list.component.scss',
  imports: [RouterLink]
})
export class SkillUsageListComponent {
  public readonly skillId = input<string>('');

  constructor(
    protected rss: RouteShareService,
    private skillUsage: SkillUsageService
  ) { }

  protected get usage(): SkillUsageStageHit[] {
    return this.skillUsage.getUsage(this.skillId());
  }
}
